/**
 * Mutation to update marketplace_seller
 */
const updateSellerMutation = `
mutation UpdateMarketplaceSeller($id: ID!, $fields: UpdateMarketplace_sellerFieldsInput) {
  updateMarketplace_seller(input: { id: $id, fields: $fields }) {
    marketplace_seller {
      objectId
      name
      phone
      slug
      email
      website
      address
      city
      zip
      enabled
      public
      b2b
      b2c
      public_prices
      ask_for_info
      plan
      updatedAt
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default updateSellerMutation;
